import * as React from 'react'

import SearchPageContainer from '../../client/containers/searchPageContainer'
import RedirectPage from '../../client/pages/redirect'
import { IRouteConfig, PageType } from '../../typings/routes'
import { redirectToItemPage } from '../utils/location'

const routeConfig: IRouteConfig[] = [
  {
    path: '/all-graphics/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/all-graphics',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/graphics-with-:term-in-:category([\\w/-]+)/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/graphics-with-:term-in-:category([\\w/-]+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:term-and-:tags-graphics-in-:category([\\w/-]+)/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:term-and-:tags-graphics-in-:category([\\w/-]+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:term-and-:tags-graphics/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.TAG
  },
  {
    path: '/:term-and-:tags-graphics',
    component: SearchPageContainer,
    pageType: PageType.TAG
  },
  {
    path: '/:tags-graphics-in-:category([\\w/-]+)/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:tags-graphics-in-:category([\\w/-]+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:term-in-graphics/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.SEARCH
  },
  {
    path: '/:term(\\d{5,})-in-graphics',
    component: ({ match }: any) => (
      <RedirectPage url={redirectToItemPage(match.params.term)} />
    ),
    pageType: PageType.SEARCH
  },
  {
    path: '/:term-in-graphics',
    component: SearchPageContainer,
    pageType: PageType.SEARCH
  },
  {
    path: '/:tags-graphics/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.TAG
  },
  {
    path: '/:tags-graphics',
    component: SearchPageContainer,
    pageType: PageType.TAG
  },
  {
    path: '/attributes/:attribute_key/:attribute_value',
    component: SearchPageContainer,
    pageType: PageType.ATTRIBUTE
  },
  {
    path: '/:category+/pg-:page(\\d+)',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  },
  {
    path: '/:category+',
    component: SearchPageContainer,
    pageType: PageType.CATEGORY
  }
]

export default routeConfig
